import React from 'react';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';

import ScorecardQuickFiltersSettings from './ScorecardQuickFiltersSettings';

const ScorecardQuickFiltersModal = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => (
  <ModalTransition>
    {isOpen && (
      <ModalDialog
        onClose={close}
        shouldScrollInViewport={false}
        autoFocus={false}
      >
        <ScorecardQuickFiltersSettings close={close} />
      </ModalDialog>
    )}
  </ModalTransition>
);

export default ScorecardQuickFiltersModal;
